class ProductCategoriesService {
  constructor (http, qs) {
    this.http = http
    this.qs = qs
  }

  async getCategories () {
    const result = await this.http.get('/categories')
    return result.data
  }

  async getCategoriesProducts (productCategories) {
    const result = await this.http.get('/categories/products', {
      params: {
        categoryIds: productCategories
      },
      paramsSerializer: params => {
        return this.qs.stringify(params)
      }
    })
    return result.data
  }
}
export default ProductCategoriesService
